import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { FloatingLabel, Form, Spinner } from "react-bootstrap"
import { toast } from "react-toastify"
import * as Yup from "yup"

import ModalComponent from "../../../components/Modal"
import { admin } from "../../../config/apiEndpoints"
import axiosProvider from "../../../lib/AxiosProvider"

const amountPattern = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/

const MinimumBalanceModal = ({
  show,
  minimumBalance,
  onHide,
  onUpdated,
}) => {
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    initialValues: {
      minimum_balance: minimumBalance || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      minimum_balance: Yup.string()
        .trim()
        .required("Minimum balance is required")
        .matches(
          amountPattern,
          "Enter a valid amount with no more than two decimal places",
        )
        .test(
          "positive-amount",
          "Minimum balance must be greater than zero",
          (value) => !value || Number(value) > 0,
        ),
    }),
    onSubmit: async (values) => {
      setLoading(true)
      try {
        const response = await axiosProvider({
          method: "PATCH",
          endpoint: admin.fleetVendorWalletMinimumBalance,
          data: {
            minimum_balance: values.minimum_balance.trim(),
          },
        })
        if (response?.data?.code !== 200) {
          throw new Error(
            response?.response?.data?.message ||
              response?.data?.message ||
              response?.message ||
              "Unable to update minimum wallet balance",
          )
        }

        toast.success(response.data.message)
        onUpdated(response.data.data)
      } catch (error) {
        toast.error(error.message || "Unable to update minimum wallet balance")
      } finally {
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    if (!show) formik.resetForm()
    // Reset only when the dialog closes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  return (
    <ModalComponent
      show={show}
      modalsize="md"
      backdrop="static"
      animationFade
      onHide={onHide}
      loading={loading}
      modeltitle="Update Minimum Wallet Balance"
      submitname={
        loading ? <Spinner size="sm" animation="border" /> : "Update"
      }
      btnclosetext="Cancel"
      handleSubmit={formik.handleSubmit}
    >
      <Form noValidate onSubmit={formik.handleSubmit}>
        <FloatingLabel
          controlId="minimum_balance"
          label="Minimum balance (₹)"
        >
          <Form.Control
            autoFocus
            type="text"
            inputMode="decimal"
            name="minimum_balance"
            placeholder="500.00"
            maxLength={15}
            value={formik.values.minimum_balance}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched.minimum_balance &&
              Boolean(formik.errors.minimum_balance)
            }
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors.minimum_balance}
          </Form.Control.Feedback>
        </FloatingLabel>
        <Form.Text className="text-body-secondary">
          This minimum applies to every Fleet Vendor wallet.
        </Form.Text>
      </Form>
    </ModalComponent>
  )
}

export default MinimumBalanceModal
